/* eslint-disable */
import {
  GET_GENDER_DROPDOWN_LIST, GET_ID_TYPE_DROPDOWN_LIST,
  ERROR_ACTION, SET_CAPTCHA_IMAGE, SET_GET_EMAIL_OTP_RESPONSE, SET_GET_MOBILE_OTP_RESPONSE, SHOW_LOADER, HIDE_LOADER, SET_VERIFY_OTP_FLAG_LOGIN, SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
  SET_GET_USERNAME_OTP_RESPONSE, SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL, SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE, SET_GUIDELINE_LINKS, SET_ADMIN_DEPARTMENTS, DASHBOARD_COUNT, SET_ADMIN_OTP_VERIFIED_FLAG, SET_MODULE_ENABLE_DISABLE,
  SET_API_CALL_FOR_MODULE, GET_OTP_DATA_EMAIL, GET_OTP_DATA_MOBILE, GET_OTP_DATA_USERNAME, SET_IS_MOBILE_NO_ALREADY_EXIST_FLG, SET_IS_EMAIL_ID_ALREADY_EXIST_FLG, SET_PROFILE_CREATION_LOOKUP, SET_GET_MOBILE_OTP_FLAG, SET_GET_EMAIL_OTP_FLAG, SET_DIGILOCKER_ACCESSTOKEN_DATA, SET_BOARDS_LIST, SET_HELPLINE_DETAILS, GRIEVANCE_DETAILS, GRIEVANCE_LIST, GET_GRIEVANCE_TYPE_DROPDOWN_LIST, SET_VERIFY_OTP_FLAG_GRIEVANCE_MOBILE, SET_GRIEVANCE_TABLE_LIST, SET_CONFIGURATION_DIGILOCKER_FLAG,
  GET_ADVERTISEMENT_TYPE_DROPDOWN_LIST, GET_TYPE_GRIEVANCE_DROPDOWN_LIST,
  GET_SUB_TYPE_GRIEVANCE_DROPDOWN_LIST,
  SET_SHOW_MODAL_VALUE,
  SET_ADMIN_GRIEVANCE_SINGLE_LIST,
  GET_WEB_APP_VERSION,
  SET_LOCK_UNLOCK_PROFILE_FLG,
  GET_SLIDE_SHOW_ACTIVE_ADVT,
  EDIT_SET_LOCK_UNLOCK_PROFILE,
  SET_OTR_DETAILS
} from "../../common/constants/ActionTypes";

const initialState = {
  errorMessage: "",
  captchaId: 0,
  loading: false,
  emailOTPResponse: {
    id: "",
    type: ""
  },
  mobileOTPResponse: {
    id: "",
    type: ""
  },
  userNameOTPResponse: {
    id: "",
    type: ""
  },
  genderDropdownList: [],
  idTypeDropdownList: [],
  verifyOTPFlag: false,
  adminOTPVerfiedFlag: false,
  verifyOTPFlagForgotPassword: false,
  verifyOTPFlagRegistrationEmail: false,
  verifyOTPFlagRegistrationMobile: false,
  verifyOTPFlagGrievanceMobile: false,
  has2018RecoLetterConfig: {},
  guidelineLinks: [],
  moduleDetails: {},
  isApiCallForModule: false,
  emailOtpData: {},
  mobileOtpData: {},
  userNameOtpData: {},
  mobileNoAlreadyExistFlg: false,
  emailIdAlreadyExistFlg: false,
  digilockerData: {},
  allLookUpList: [],
  getMobileOTPFlag: false,
  getEmailOTPFlag: false,
  boardsList: {},
  getHelpLineList: [],
  grievanceList: [],
  grievanceDetails: {},
  grievanceTypes: [],
  grievanceTableList: [],
  digilockerFlg: 0,
  advertisementDropdown: [],
  sub_grievance_type_list: [],
  grievance_type_list: [],
  web_app_version: "",
  lockUnlockProfileFlg: false,
  activeAdvtSlideShowList: [],
  enableEditProfileWithLock: false,
  otrDetails: {},
  showPreferences: false
}

export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case GET_GENDER_DROPDOWN_LIST:
      return {
        ...state,
        genderDropdownList: action.payload,
      };
    case GET_ID_TYPE_DROPDOWN_LIST:
      return {
        ...state,
        idTypeDropdownList: action.payload,
      };
    case SET_CAPTCHA_IMAGE:
      return {
        ...state,
        captchaId: action.payload,
      };
    case SHOW_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_GET_EMAIL_OTP_RESPONSE:
      return {
        ...state,
        emailOTPResponse: action.payload,
      };
    case SET_GET_MOBILE_OTP_RESPONSE:
      return {
        ...state,
        mobileOTPResponse: action.payload,
      };
    case SET_GET_USERNAME_OTP_RESPONSE:
      return {
        ...state,
        userNameOTPResponse: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_LOGIN:
      return {
        ...state,
        verifyOTPFlag: action.payload,
      };
    case SET_ADMIN_OTP_VERIFIED_FLAG:
      return {
        ...state,
        adminOTPVerfiedFlag: action.payload
      }
    case SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD:
      return {
        ...state,
        verifyOTPFlagForgotPassword: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL:
      return {
        ...state,
        verifyOTPFlagRegistrationEmail: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE:
      return {
        ...state,
        verifyOTPFlagRegistrationMobile: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_GRIEVANCE_MOBILE:
      return {
        ...state,
        verifyOTPFlagGrievanceMobile: action.payload,
      };
    case "set_has_2018_reco_letter_config":
      return {
        ...state,
        has2018RecoLetterConfig: action.payload,
      };
    case SET_GUIDELINE_LINKS:
      return {
        ...state,
        guidelineLinks: action.payload,
      };
    case SET_ADMIN_DEPARTMENTS:
      return {
        ...state,
        adminDepartments: action.payload
      }
    case DASHBOARD_COUNT:
      return {
        ...state,
        dashboardCount: action.payload
      }
    case SET_MODULE_ENABLE_DISABLE:
      return {
        ...state,
        moduleDetails: action.payload,
      };
    case SET_API_CALL_FOR_MODULE:
      return {
        ...state,
        isApiCallForModule: action.payload,
      };
    case GET_OTP_DATA_EMAIL:
      return {
        ...state,
        emailOtpData: action.payload,
      };
    case GET_OTP_DATA_MOBILE:
      return {
        ...state,
        mobileOtpData: action.payload,
      };
    case GET_OTP_DATA_USERNAME:
      return {
        ...state,
        userNameOtpData: action.payload,
      };
    case SET_IS_MOBILE_NO_ALREADY_EXIST_FLG:
      return {
        ...state,
        mobileNoAlreadyExistFlg: action.payload,
      };
    case SET_IS_EMAIL_ID_ALREADY_EXIST_FLG:
      return {
        ...state,
        emailIdAlreadyExistFlg: action.payload,
      };

    case SET_DIGILOCKER_ACCESSTOKEN_DATA:
      return {
        ...state,
        digilockerData: action.payload,
      };
    case SET_PROFILE_CREATION_LOOKUP:
      return {
        ...state,
        allLookUpList: action.payload,
      };
    case SET_GET_MOBILE_OTP_FLAG:
      return {
        ...state,
        getMobileOTPFlag: action.payload,
      };
    case SET_GET_EMAIL_OTP_FLAG:
      return {
        ...state,
        getEmailOTPFlag: action.payload,
      };
    case SET_BOARDS_LIST:
      return {
        ...state,
        boardsList: action.payload,
      };
    case SET_HELPLINE_DETAILS:
      return {
        ...state,
        getHelpLineList: action.payload,
      };
    case GRIEVANCE_DETAILS:
      return {
        ...state,
        grievanceDetails: action.payload
      };
    case GRIEVANCE_LIST:
      return {
        ...state,
        grievanceList: action.payload
      };
    case GET_GRIEVANCE_TYPE_DROPDOWN_LIST:
      return {
        ...state,
        grievanceTypes: action.payload
      };
    case SET_GRIEVANCE_TABLE_LIST:
      return {
        ...state,
        grievanceTableList: action.payload,
      };
    case SET_CONFIGURATION_DIGILOCKER_FLAG:
      return {
        ...state,
        digilockerFlg: action.payload,
      };
    case GET_ADVERTISEMENT_TYPE_DROPDOWN_LIST:
      return {
        ...state,
        advertisementDropdown: action.payload
      };
    case GET_TYPE_GRIEVANCE_DROPDOWN_LIST:
      return {
        ...state,
        grievance_type_list: action.payload
      };
    case GET_SUB_TYPE_GRIEVANCE_DROPDOWN_LIST:
      return {
        ...state,
        sub_grievance_type_list: action.payload
      };
    case GET_WEB_APP_VERSION:
      return {
        ...state,
        web_app_version: action.payload
      };
    case SET_LOCK_UNLOCK_PROFILE_FLG:
      return {
        ...state,
        lockUnlockProfileFlg: action.payload
      };
    case GET_SLIDE_SHOW_ACTIVE_ADVT:
      return {
        ...state,
        activeAdvtSlideShowList: action.payload
      };

    case EDIT_SET_LOCK_UNLOCK_PROFILE:
      return {
        ...state,
        enableEditProfileWithLock: action.payload
      };
    case SET_OTR_DETAILS:
      return {
        ...state,
        otrDetails: action.payload
      }
    default:
      return state;
  }
}
